// Autogenerated file
export const simplifiedTypeCodesEnum = {
    Integer: "Integer",
    Float: "Float",
    Boolean: "Boolean",
    String: "String",
    DateTime: "DateTime",
    DateTimeWithoutTimezone: "DateTimeWithoutTimezone",
};
export const simplifiedTypeCodes = [
    { label: "Целое число", value: "Integer" },
    { label: "Число с точкой", value: "Float" },
    { label: "Булево", value: "Boolean" },
    { label: "Строка", value: "String" },
    { label: "Дата с часовым поясом", value: "DateTime" },
    { label: "Дата", value: "DateTimeWithoutTimezone" },
];
